export const HOME_ROUTE = '/home';
export const FORBIDDEN_ROUTE = 'forbidden';
export const FORBIDDEN_APP_ROUTE = 'forbidden-app';
export const MAINTENANCE_APP_ROUTE = 'maintenance';
export const AUTH_ROUTE = '/';
export const GPW_SYSTEM_MANAGEMENT_ROUTE = 'gpw-system-management';
export const GPW_SYSTEM_MANAGEMENT_TITLE = 'Gestión del Sistema GPW';
export const BULK_LOADS_ROUTE = 'bulk-loads';
export const BULK_LOADS_TITLE = 'Cargas Masivas';
export const ESTABLISHMENT_MANAGEMENT_ROUTE = 'establishment-management';
export const ESTABLISHMENT_MANAGEMENT_TITLE = 'Gestión de Establecimientos';
export const USER_MANAGEMENT_ROUTE = 'user-management';
export const USER_MANAGEMENT_TITLE = 'Gestión de Usuarios';
export const INFANT_MANAGEMENT_ROUTE = 'infant-management';
export const INFANT_MANAGEMENT_TITLE = 'Gestión de Párvulos';
export const MAINTAINER_MANAGEMENT_ROUTE = 'maintainer-management';
export const MAINTAINER_MANAGEMENT_TITLE = 'Mantenedor Maestras';
export const MAINTAINER_MENU_ROUTE = 'gestion';
export const MAINTAINER_MENU_TITLE = 'Gestión de Funciones y Permisos';
export const MAINTAINER_GPW_ROUTE = 'gpw';
export const MAINTAINER_GPW_TITLE = 'X';
